import { useDispatch, useSelector } from 'react-redux';
import { sync } from 'shared/wizard/actions';
import { HeaderForm } from 'shared/forms';
import { LabelText } from 'shared/components';
import { currencyFormatter } from '@dnhb/formatters';
import { CurrencyInput, SelectInput, Checkbox } from 'shared/inputs';
import { func } from 'react-proptypes';
import styled from '@emotion/styled';

const OverviewHeaderContainer = styled(HeaderForm)(({ theme }) => `
  display: flex;
  justify-content: flex-start;
  margin-bottom: 24px;

  > div {
    margin-right: 16px;
    &:not(:last-of-type) {
      flex-basis: 25%;
    }
  }
  @media ${theme.mobile} {
    flex-flow: column nowrap;
    justify-content: start;

    > div {
      margin: 8px 0;
      width: 100%;
      &:not(:last-of-type) {
        flex-basis: auto;
      }
    }
  }
`);

const OverviewHeader = ({ handleChange }) => {
  const dispatch = useDispatch();
  const { input, output: {errors} } = useSelector(state => state);
  const options = [...Array(30).keys()].map(i => ({
    value: (i + 1) * 12,
    label: `${i + 1} jaar`,
  }));

  const tags = [
    {
      label: 'Vraagprijs',
      value: currencyFormatter(input.house_value),
    },
    {
      label: 'Eigen geld',
      value: currencyFormatter(input.own_resources || 0),
    },
    {
      label: 'NHG',
      value: input.has_nhg,
    },
    {
      label: 'Rentevaste periode',
      value: (options.find(option => option.value === input.fixed_rate_term) || {}).label,
    },
  ];

  return (
    <OverviewHeaderContainer
      buttonTitle={input.openForm ? 'Berekenen' : 'Berekening aanpassen'}
      tags={tags}
      setMobileFormOpen={() => sync(dispatch)('openForm', !input.openForm)}
      mobileFormOpen={!input.openForm}
      hasErrors={Boolean(Object.keys(errors).length)}
    >
      <div>
        <LabelText>Vraagprijs/waarde van de woning</LabelText>
        <CurrencyInput
          id="house_value"
          onChange={e => handleChange('house_value', e.target.value)}
          value={input.house_value}
          errors={errors.house_value}
          placeholder="Vraagprijs"
        />
      </div>
      <div>
        <LabelText>Inbreng eigen geld</LabelText>
        <CurrencyInput
          id="own_resources"
          onChange={e => handleChange('own_resources', e.target.value)}
          value={input.own_resources}
          errors={errors.own_resources}
          placeholder="Eigen geld"
        />
      </div>
      <div>
        <LabelText>Rentevasteperiode</LabelText>
        <SelectInput
          placeholder="Rentevasteperiode"
          options={options}
          value={input.fixed_rate_term}
          errors={errors.fixed_rate_term}
          onChange={option => handleChange('fixed_rate_term', option.value) }
          isSearchable
        />
      </div>
      <div css={{ display: 'flex', alignItems: 'center', margin: '30px 8px 0' }}>
        <Checkbox
          name="has_nhg"
          label="NHG?"
          value={input.has_nhg}
          errors={errors.has_nhg}
          onChange={e => handleChange('has_nhg', e.target.value)}
        />
      </div>
    </OverviewHeaderContainer>
  );
}

OverviewHeader.propTypes = {
  handleChange: func,
};

OverviewHeader.defaultProps = {
  handleChange: () => {}
};

export default OverviewHeader;
